import { useSearch } from "wouter-preact";
import type { ComponentChildren } from "preact";
import { PaymentLayout } from "../../components/PaymentLayout";
import { OnboardingFlow } from "../onboarding/OnboardingFlow";
import { useSiteConfig } from "../tenant/SiteConfigContext";

export function SessionInitialization({ children }: { children: ComponentChildren }) {
  const site = useSiteConfig();
  const search = useSearch();
  const token = new URLSearchParams(search).get("accessToken");

  function clearAccessToken() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("accessToken")) return;
    url.searchParams.delete("accessToken");
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );
  }

  if (!token) return <>{children}</>;
  return (
    <PaymentLayout>
      <section class="sign-in-page" aria-label="Account sign in">
        <div class="search-card">
          <OnboardingFlow
            key={token}
            providerName={site.displayName}
            accessToken={token}
            onComplete={clearAccessToken}
            onAccessTokenRejected={clearAccessToken}
          />
        </div>
      </section>
    </PaymentLayout>
  );
}
